import React from 'react';
import { Button, Modal } from 'antd';
import API_URL from '../../common/url';
import $ from '../../common/AjaxRequest';
import TableC from '../basicElement/TableC';
import format from '../shared/format';

class UserDetail extends React.Component {
    state = {
        visible: false,
        loading: false,
        user: {},
        invList: [],
    }

    loadData = (userId) => {
        this.setState({ loading: true });
        const options = {
            url: API_URL.user.getUserDetail,
            data: { userId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { userInfo, invList } = data || {};
                this.setState({
                    loading: false,
                    user: userInfo || {},
                    invList: invList || [],
                });
            },
            errorResult: () => {
                this.setState({loading: false });
            },
        };
        $.sendRequest(options);
    }

    show = userId => {
        this.setState({ visible: true }, () => {
            this.loadData(userId);
        });
    }

    getColumns = () => {
        const columns = [
            {
                title: '项目编号',
                dataIndex: 'investigationCode',
                key: 'investigationCode',
                width: 90,
            }, {
                title: '项目简称',
                dataIndex: 'investigationName',
                key: 'investigationName',
                width: 120,
            }, {
                title: '业务线',
                dataIndex: 'lineOfBusinessString',
                key: 'lineOfBusinessString',
                width: 80,
            }, {
                title: '执行业务线二级分类',
                dataIndex: 'secondLineNames',
                key: 'secondLineNames',
                width: 80,
            }, {
                title: '中心编号',
                dataIndex: 'investigationSiteCode',
                key: 'investigationSiteCode',
                width: 90,
            }, {
                title: '中心名称',
                dataIndex: 'investigationSiteName',
                key: 'investigationSiteName',
                width: 120,
            }, {
                title: '区域',
                dataIndex: 'areaName',
                key: 'areaName',
                width: 90,
            }, {
                title: '城市',
                dataIndex: 'cityName',
                key: 'cityName',
                width: 90,
            }, {
                title: '项目领域',
                dataIndex: 'investigationAreaName',
                key: 'investigationAreaName',
                width: 80,
            }, {
                title: '疾病',
                dataIndex: 'diseaseName',
                key: 'diseaseName',
                width: 80,
            }, {
                title: '研究产品类型',
                dataIndex: 'investigationMedicineName',
                key: 'investigationMedicineName',
                width: 90,
            }, {
                title: '当月计划FTE',
                dataIndex: 'planFTE',
                key: 'planFTE',
                width: 90,
            }
        ];
        return columns;
    }

    getDataSource = () => {
        const { invList } = this.state;
        const dataSource = (invList || []).map((dataItem, i) => ({
            investigationSiteId: dataItem.investigation_site_id,
            investigationCode: dataItem.investigation_code,
            investigationName: dataItem.investigation_name,
            investigationSiteCode: dataItem.investigation_site_code,
            investigationSiteName: dataItem.investigation_site_name,
            investigationMalady: dataItem.investigation_malady,
            investigationMedicine: dataItem.investigation_medicine,
            planFTE: dataItem.plan_fte_sum,
            investigationAreaName: dataItem.investigationAreaName,
            diseaseName: dataItem.diseaseName,
            investigationMedicineName: dataItem.investigationMedicineName,
            lineOfBusinessString: dataItem.lineOfBusinessString,
            secondLineNames: dataItem.secondLineNames,
            areaName: dataItem.areaName,
            cityName: dataItem.cityName,
        }));
        return dataSource;
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, loading, user } = this.state;
        const {
            employeeCode,
            userName,
            positionName,
            leader,
            enterpriseDepartmentName,
            workCity,
            joinTime,
            mobile,
            email,
            gender,
            placeOfOrigin,
            education,
            graduate,
            subject,
            graduateTime,
            lastCompany,
            workBeginTime,
        } = user;
        const { userName: leaderName } = leader || {};
        return (
            <Modal
                title='人员信息'
                visible={visible}
                onCancel={this.hide}
                width={1000}
                maskClosable={false}
                confirmLoading={loading}
                bodyStyle={{ maxHeight: 600 }}
                footer={[<Button type="ghost" onClick={this.hide}>关闭</Button>,]}
            >
                <ul className="preview-list">
                        <li className="title preview-item"><h4>1.员工基本信息</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">工号</label>
                                <span className="ui-text">{employeeCode}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">姓名</label>
                                <span className="ui-text">{userName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">职位</label>
                                <span className="ui-text">{positionName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">主管领导</label>
                                <span className="ui-text">{leaderName}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">部门</label>
                                <span className="ui-text">{enterpriseDepartmentName}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">工作地点</label>
                                <span className="ui-text">{workCity}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">入职时间</label>
                                <span className="ui-text">{format('date', joinTime)}</span>
                            </div>
                        </li>
                        <li className="title preview-item"><h4>2.联系方式</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">手机号码</label>
                                <span className="ui-text">{mobile}</span>
                            </div>                           
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">邮箱</label>
                                <span className="ui-text">{email}</span>
                            </div>
                            <div className="item">
                                
                            </div>
                        </li>
                        <li className="title preview-item"><h4>3.个人信息</h4></li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">性别</label>
                                <span className="ui-text">{gender ? gender === 'MALE'? '男': '女' : '' }</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">籍贯</label>
                                <span className="ui-text">{placeOfOrigin}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">学历</label>
                                <span className="ui-text">{education}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">毕业院校</label>
                                <span className="ui-text">{graduate}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">专业</label>
                                <span className="ui-text">{subject}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">毕业时间</label>
                                <span className="ui-text">{format('date', graduateTime)}</span>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item">
                                <label className="ui-label">上家公司</label>
                                <span className="ui-text">{lastCompany}</span>
                            </div>
                            <div className="item">
                                <label className="ui-label">从事临床研究&nbsp;&nbsp;&nbsp;&nbsp;<br />起始时间</label>
                                <span className="ui-text">{format('date', workBeginTime)}</span>
                            </div>
                        </li>
                        <li className="title preview-item"><h4>4.进行中项目</h4></li>
                        <li className="preview-item user-detail">
                            <TableC  
                                columns={this.getColumns()}
                                data={this.getDataSource()}
                                loading={loading}
                                scrollY={400}
                                className="userDetail"
                            />
                        </li>
                    </ul>
            </Modal>
        )
    }
}

export default UserDetail;



// WEBPACK FOOTER //
// ./src/components/user/UserDetail.js